import { Bounce, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './ToastrNotifi.css';

const ToastrNotifi = {
    infoToast: (message1) => {
        toast.info(message1, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
            className:"custom-toast",
        });
    },
    successToast: (message2) => {
        toast.success(message2, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
            
        });
    },
    warningToast: (message3) => {
        toast.warning(message3, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
        });
    },
    errorToast: (message4) => {
        toast.error(message4, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
            className:"custom-toast",
        });
    }
};

export default ToastrNotifi;